<template>
  <v-menu
      :close-on-content-click="false"
      offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          class="ml-5"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
      >
        {{ languageData.generatePdf }}
        <v-icon class="ml-2">
          mdi-format-list-bulleted-square
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <template v-if="isProjectReportGenerating">
        <v-list-item>
            <v-list-item-title>
              <v-progress-circular
                  indeterminate
                  color="primary"
              ></v-progress-circular>
            </v-list-item-title>
        </v-list-item>
      </template>
      <template v-else>
        <v-list-item link @click="generateProjectReportPdf">
          <v-list-item-title>{{ languageData.projectReport }}</v-list-item-title>
        </v-list-item>
      </template>
      <template v-if="isEstimationGenerating">
        <v-list-item link>
          <v-list-item-title>
              <v-progress-circular
                  indeterminate
                  color="primary"
              ></v-progress-circular>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-else>
        <v-list-item link @click="generateEstimationPdf">
          <v-list-item-title>{{ languageData.estimation }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  name: "GeneratePdfMenu",
  data() {
    return {

    }
  },
  computed: {
    ...mapState("generateProjectReportPdf", {
      isProjectReportGenerating: state => state.isProjectReportGenerating
    }),
    ...mapState("generateEstimation", {
      isEstimationGenerating: state => state.isEstimationGenerating
    })
  },
  methods: {
    ...mapActions("generateProjectReportPdf", ["generateProjectReport"]),
    ...mapActions("generateEstimation", ["generateEstimation"]),
    generateProjectReportPdf: function() {
      this.generateProjectReport();
    },
    generateEstimationPdf() {
      this.generateEstimation();
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>